type MiddlewareMeta = {
  forceCollapse?: boolean
}

export default defineNuxtRouteMiddleware(async (to) => {
  const { $sidebarForcedCollapsed } = useNuxtApp()

  const sidebarOptions = to.meta.sidebar as MiddlewareMeta | null

  if (sidebarOptions?.forceCollapse) {
    $sidebarForcedCollapsed.value = true
    return
  }
  $sidebarForcedCollapsed.value = false
})
